export default __webpack_public_path__ + "static/media/cuddlynest.f9d703af.png";